<script>
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'

export default {
  mixins: [layout, NavigateMixin],
  emits: ['close-dialog'],
  props: {
    showAlert: {
      type: Boolean,
      default: false,
      required: true,
    },
    alertMessage: {
      type: String,
      default: '',
      required: true,
    },
    alertTitle: {
      type: String,
      default: '',
      required: false,
    },
    linkText: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {}
  },

  mounted: function () {},
  methods: {
    successCallBack() {
      this.$emit('success')
    },
    dismissAlert() {
      this.showAlert = false
      this.$emit('close-alert')
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-dialog
      v-model="showAlert"
      scrollable
      persistent
      min-width="200"
      max-width="300"
      no-click-animation
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
      :fullscreen="mobile"
    >
      <v-card :class="$style.dialogContainer">
        <v-card-text :class="$style.chatContainer" class="text-center">
          <div :class="$style.queueTextContainer">
            <p :class="$style.titleText">
              {{ alertTitle }}
            </p>
          </div>
          <div :class="$style.textContainer">
            <p :class="$style.titleText">
              {{ alertMessage }}
            </p>
          </div>
          <v-row :class="$style.buttonContainer">
            <div class="pa-3">
              <a
                class="clickable primary--text"
                :class="$style.hrRouterLinkText"
                @click="dismissAlert"
              >
                Ok
              </a>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  background-color: #fff !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.chatContainer {
  margin-top: 0;
}

.queueTextContainer {
  margin-top: 10px;
}

.titleText {
  font-size: 14px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  letter-spacing: 0;
}

.textContainer {
  display: flex;
  flex-direction: column;
}

.alertText {
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  letter-spacing: 0;
  word-wrap: break-word;
}

.buttonContainer {
  align-items: center;
}

.vl {
  height: 20px;
  border-left: 3px solid rgb(206, 206, 206);
}

.hrRouterLinkTextStrong {
  font-size: 18px;
  font-weight: 800;
}

.hrRouterLinkText {
  font-size: 14px;
}
.privacyText {
  font-size: 15px;
  font-weight: 400;
  line-height: 10px;
  color: #0476d9;
  text-align: left;
  text-decoration: none;
  letter-spacing: 0;
}

@media screen and (max-width: 600px) {
  .chatContainer {
    margin-top: 50%;
  }
}
</style>
